export default "__VITE_ASSET__1f92446c__"